<template>
    <div class="container">
        <div class="content">
             <el-form :inline="true" :model="searchForm" ref="searchForm" class="search-form" size="small" label-width="64px">
                <el-form-item label="审批流名称">
                    <template #label>
                        <div class="label-con">
                            <div>审批流</div>
                            <div>名称</div>
                        </div>
                    </template>
                    <el-select v-model="searchForm.templateName" placeholder="请选择" clearable filterable>
                        <el-option
                            v-for="(item,index) in templateNameList"
                            :key="index"
                            :label="item"
                            :value="item">
                            </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="指定功能">
                    <el-select v-model="searchForm.function" placeholder="请选择" clearable>
                        <el-option v-for="(label,value) in functionMap" :label="label" :value="value" :key="value">
                        </el-option>
                    </el-select>
                </el-form-item>
            
                <el-form-item>
                    <div class="flex">
                        <div class="s-btn" @click="fetchData('search')">查询</div>
                        <div class="r-btn" @click="fetchData('reset')">重置</div>
                    </div>
                </el-form-item>
            </el-form>
            <div class="line"></div>
            <div class="data-title">
                <div style="display: flex;height: 32px;">
                    <div class="title-line"></div>
                    <div class="title-name">数据列表</div>
                </div>
            </div>
            <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="totalNum" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                :current-page.sync="page.pageNo" :page-size="page.pageSize" @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
            </lb-table>
        </div>
    </div>
</template>
<script>
import LbTable from '@/components/lb-table/lb-table'

export default {
    name: 'processManagement',
    components: {
        LbTable,
    },
    data() {
        return {
            templateNameList:[],
            searchForm: {
                templateName: '',
                function: '',
                pageNo: 1,
                pageSize: 10,
            },
            parArray: [],
            groupId: '',
            page: {
                pageNo: 1,
                pageSize: 10
            },
            functionMap: {
                '1': '转移',
                '2': '公告审批',
                '3': '采购审批',
            },
            list: [],
            totalNum: 0,
            loading: false,
            columns: [
                { label: '排序', type:"index", width: '60' },
                { label: '审批流名称', prop: 'templateName', minWidth: '120', align:'left' ,
                    render: (h, scope) => {
                        return (
                            <div class="align-left">
                               {scope.row.templateName}
                            </div>
                        )
                    }
                },
                { label: '审批流说明', prop: 'remark', minWidth: '160', align:'left',
                    render: (h, scope) => {
                        return (
                            <div class="ellipsis2">
                                { scope.row.remark }
                            </div>
                        )
                    }
                 },
                 { label: '指定功能', prop: 'function', width: '160',
                   renderHeader: () => {
                        return (
                            <div class='align-center'>指定功能</div>
                        )
                    },
                    render: (h, scope) => {
                        return (
                            <div class="align-center">{scope.row.function}</div>
                        )
                    }
                },
                { label: '最后更新', width: '170', align:'left',
                    render: (h, scope) => {
                        return (
                            <div class="align-left">
                               {scope.row.updatedName}<br/>{scope.row.updatedTime}
                            </div>
                        )
                    }
                },
                {
                    label: '操作', prop: 'orgName', width: '140', fixed: 'right', align: 'center',
                    render: (h, scope) => {
                        return (
                            <div style="display:flex;justify-content:center">
                                <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.lookList(scope.row) }} >数据</div>
                                <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.toEdit(scope.row) }} >查看/编辑</div>
                            </div>
                        )
                    }
                },
            ],
        }
    },
    created() {
        
    },
    activated() {
        this.fetchData()
        this.getTemplateNameList()
    },
    mounted() {

    },
    methods: {
        getTemplateNameList(){
            this.$api.workflowNameList().then(res=>{
                if(res.code == 0){
                    let list =  res.data || []
                    let processList = list.filter(e=>e.isSystem)
                    this.templateNameList = processList.map(e=>e.templateName)
                }
            })
        },
        handleCurrentChange(e) {
            this.page.pageNo = e
            this.fetchData()
        },
        handleSizeChange(e) {
            this.page.pageSize = e
            this.fetchData()
        },
        

        fetchData(type) {
             if (type == 'reset') {
                this.page.pageNo = 1
                this.searchForm.templateName =  ''
                this.searchForm.function =  ''

             }
            if (type == 'search') {
                this.page.pageNo = 1
            }
            this.loading = true
            this.searchForm.pageNo = this.page.pageNo
            this.searchForm.pageSize = this.page.pageSize
            
            this.$api.workflowList(this.searchForm).then((res) => {
                if (res.code == 0) {
                    this.list = res.data.list
                    this.totalNum = res.data.totalNum
                }
            }).finally(() => {
                this.loading = false
            })
        },
        // 查看数据
        lookList(item){
            // 修改导航
            localStorage.setItem('selectedMenuIndex', '/officeApproval/approvalAllList')
            this.$router.push({ name: 'approvalAllList',query:{pName:item.templateName} })
        },
        toEdit(item) {
            this.$store.commit("setIsEdit", true);
            this.$router.push({ path: '/officeApproval/processManagement/editProcess',query:{id:item.id,groupId:item.groupId} })
         },
    }
}
</script>

<style scoped lang="scss">
.container {
    width: 100%;
    height: 100%;
     /deep/ .el-table {
         th>.cell {
            text-align: left;
          }
          th.el-table-column--selection >.cell {
            text-align: center;
          }
    }
    .content {
        width: 100%;
        min-height: calc(100vh - 117px);
        margin-top: 16px;
        background-color: white;
        padding-left: 16px;
        padding-right: 16px;
        box-sizing: border-box;
        padding-bottom: 16px;
        border-bottom: 32px solid #F5FAF9;
        border-radius: 8px 8px 8px 8px / 8px 8px 40px 40px;
         .search-form {
                padding-top: 32px;
            }

            .line {
                width: 100%;
                height: 1px;
                background: #EDF2F2;
                border-radius: 0px 0px 0px 0px;
                margin-top: 16px;
            }
        .data-title {
            width: 100%;
            height: 32px;
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title-line {
                width: 2px;
                height: 16px;
                background: #00B498;
                border-radius: 0px 0px 0px 0px;
                margin-top: 8px;
            }

            .title-name {
                font-family: PingFang SC, PingFang SC;
                font-weight: bold;
                font-size: 16px;
                color: #2F3030;
                margin-left: 4px;
                line-height: 32px;
            }
        }
        .label-con {
            width: 64px;
            display: flex;
            justify-content: space-between;
            box-sizing: border-box;
            padding-right: 8px;
            flex-direction: column;
            line-height: 16px;
        }
    }


}
</style>
